import WebView from "@/Layouts/WebView";
import {Head, useForm, usePage} from "@inertiajs/inertia-react";
import React from "react";
import ProductLogo from "@/Components/ProductLogo";
import {FormCheckbox, FormInput, PhoneOrEmailInput, termsLabel} from "@/Components/Controls";
import i18n from "i18next";
import Button from "@/Components/Button";
import ValidationErrors from "@/Components/ValidationErrors";
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";

export default function CreateAccount() {
    const organization = usePage().props.organization;

    const {data, setData, post, errors, processing} = useForm({
        email_or_phone: '',
        first_name: '',
        last_name: '',
        agree_to_terms: false,
    });

    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        post(route('webview.join.create-account.store', organization));
    };

    return (
        <WebView>
            <Head>
                <title>Create an Account</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className="create-account">
                <ProductLogo />
                <form onSubmit={submit}>
                    <ValidationErrors errors={errors["email"] ? {email: errors["email"]} : {}}/>
                    <div className="row">
                        <PhoneOrEmailInput
                            name="email_or_phone"
                            error={errors["email_or_phone"]}
                            isFocused={true}
                            autoComplete="username"
                            value={data.email_or_phone}
                            onChange={onChange}
                            label={i18n.t("login.email-or-phone")}
                            className="col-12"
                            dataQa="create-account-email-or-phone"
                        />
                    </div>

                    <div className="row">
                        <FormInput
                            error={errors["first_name"]}
                            name="first_name"
                            autoComplete="first_name"
                            value={data.first_name} onChange={onChange}
                            label={i18n.t("join-organization.first-name")} className="col-12"
                            dataQa="create-account-first-name"
                        />
                    </div>

                    <div className="row">
                        <FormInput
                            error={errors["last_name"]}
                            name="last_name"
                            autoComplete="last_name"
                            value={data.last_name} onChange={onChange}
                            label={i18n.t("join-organization.last-name")} className="col-12"
                            dataQa="create-account-last-name"
                        />
                    </div>

                    <div className="row">
                        <FormCheckbox
                            error={errors["agree_to_terms"]}
                            name="agree_to_terms"
                            label={termsLabel()}
                            onChange={onChange}
                            value={data.agree_to_terms}
                            className="col-12 small"
                            dataQa="create-account-terms"
                        />
                    </div>

                    <div className="">
                        <Button className="w-100 btn btn-primary" processing={processing} type="submit">
                            <span>{i18n.t("signup.continue")}</span>
                        </Button>
                    </div>
                </form>
            </div>
        </WebView>
    )
}
